<template>
  <div class="animated fadeIn">
    <div class="row mb-20">
      <div class="col-6">
        <a @click="openPage('/allForm')" class="btn-grey"><i class="fas fa-arrow-circle-left mr-5"></i>Back</a>
      </div>
    </div>
    <div class="box">
      <div class="p-20">
        <template>
          <form @submit.prevent="validateLostAndFound('lostAndFound')" data-vv-scope="lostAndFound">
            <div class="row justify-content-center mt-30">
              <div class="col-sm-6">
                <b-row class="mb-20">
                  <b-col sm="3">
                    <label>Pickup Name</label>
                  </b-col>
                  <b-col sm="9">
                    <b-form-input class="border-bottom" name="who_return_item_name" v-validate="'required'" v-model="editData.who_return_item_name" type="text"></b-form-input>
                    <span class="error">{{ errors.first('lostAndFound.who_return_item_name') }}</span>
                  </b-col>
                </b-row>
                <b-row class="mb-20">
                  <b-col sm="3">
                    <label>Pickup Time</label>
                  </b-col>
                  <b-col sm="9">
                    <flat-pickr :config="configTimeDate" v-model="editData.return_item_time" name="return_time_found" class="w-100 border-bottom"></flat-pickr>
                  </b-col>
                </b-row>

                <b-row class="mb-20">
                  <b-col sm="3">
                    <label>Branch</label>
                  </b-col>
                  <b-col sm="9">
                    <b-form-select name="branch" v-model="editData.branch_id" @change="changeBranch">
                      <option :value="null">Please select</option>
                      <option v-for="item in dataBranch" :key="item.id" :value="item.id">{{item.name}}</option>
                    </b-form-select>
                  </b-col>
                </b-row>

                <b-row class="mb-20">
                  <b-col sm="3">
                    <label>Customer Service Serve</label>
                  </b-col>
                  <b-col sm="9">
                    <b-form-select class="border-bottom" name="customer_service_id" v-validate="'required'" v-model="editData.customer_service_serve_id">
                      <option :value="''">Please select</option>
                      <option v-for="itemCsName in dataCS" :key="itemCsName.id" :value="itemCsName.id">
                        {{itemCsName.name}}
                      </option>
                    </b-form-select>
                    <span class="error">{{ errors.first('lostAndFound.customer_service_id') }}</span>
                  </b-col>
                </b-row>
              </div>
              <div class="col-sm-6">
              </div>
            </div>
            <hr>
            <div class="row justify-content-center mt-30">
              <div class="col-sm-6">
                <b-row class="mb-20">
                  <b-col sm="3">
                    <label>Item Name</label>
                  </b-col>
                  <b-col sm="9">
                    <b-form-input class="border-bottom" name="item_name" v-validate="'required'" v-model="editData.what_item" type="text"></b-form-input>
                    <span class="error">{{ errors.first('lostAndFound.item_name') }}</span>
                  </b-col>
                </b-row>
                <b-row class="mb-20">
                  <b-col sm="3">
                    <label>Detail</label>
                  </b-col>
                  <b-col sm="9">
                    <b-form-input class="border-bottom" name="detail" v-validate="'required'" v-model="editData.detail_reason" type="text"></b-form-input>
                    <span class="error">{{ errors.first('lostAndFound.detail') }}</span>
                  </b-col>
                </b-row>
                <b-row class="mb-20">
                  <b-col sm="3">
                    <label>Employee ID</label>
                  </b-col>
                  <b-col sm="9">
                    <b-form-select @change="getCSData" class="border-bottom" name="customer_service_id" v-validate="'required'" v-model="editData.customer_service_id">
                      <option :value="null">Please select</option>
                      <option v-for="item in dataCS" :key="item.id" :value="item.id">
                        <template v-if="item.branch">{{item.branch.codename}}</template><template v-else>XX</template>-{{item.id}}
                      </option>
                    </b-form-select>
                    <span class="error">{{ errors.first('lostAndFound.customer_service_id') }}</span>
                  </b-col>
                </b-row>
                <b-row class="mb-20">
                  <b-col sm="3">
                    <label>Customer Service Name</label>
                  </b-col>
                  <b-col sm="9">
                    <b-form-input class="border-bottom bg-transparent" disabled v-model="CSName" type="text"></b-form-input>
                  </b-col>
                </b-row>
              </div>
              <div class="col-sm-6">
                <b-row class="mb-20">
                  <b-col sm="3">
                    <label>Founder Name</label>
                  </b-col>
                  <b-col sm="9">
                    <b-form-input class="border-bottom" name="founder_name" v-validate="'required'" v-model="editData.which_found_name" type="text"></b-form-input>
                    <span class="error">{{ errors.first('lostAndFound.founder_name') }}</span>
                  </b-col>
                </b-row>
                <b-row class="mb-20">
                  <b-col sm="3">
                    <label>Area/Location</label>
                  </b-col>
                  <b-col sm="9">
                    <b-form-input class="border-bottom" name="location" v-validate="'required'" v-model="editData.which_area" type="text"></b-form-input>
                    <span class="error">{{ errors.first('lostAndFound.location') }}</span>
                  </b-col>
                </b-row>
                <b-row class="mb-20">
                  <b-col sm="3">
                    <label>Time Found</label>
                  </b-col>
                  <b-col sm="9">
                    <flat-pickr :config="configTimeDate" v-model="editData.time_found" name="time_found" class="w-100 border-bottom"></flat-pickr>
                    <span class="error">{{ errors.first('lostAndFound.time_found') }}</span>
                  </b-col>
                </b-row>
              </div>
            </div>
            <div class="text-right">
              <button :disabled="disableBtnSubmit" type="submit" class="btn-primary" data-fancybox data-type="iframe" :data-src="linkPrivyId">Submit</button>
              <b-modal modal-class="modal-custom-privy" hide-footer hide-header v-model="modalShow" centered title="Checkout">
              <div class="container-iframe">
                <iframe id="paymentFrame" v-show="linkPrivyId" :src="linkPrivyId" class="w-100" frameborder="0"></iframe>
              </div>
            </b-modal>
            </div>
          </form>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { Callout } from '@coreui/vue'
import axios from 'axios'
import { Auth } from '@/api'
import moment from 'moment'

export default {
  name: 'addbranch',
  data: function () {
    return {
      disableBtnSubmit: false,
      errorMoney: 'The amount field is required!',
      dataMember: [],
      dataBranch: [],
      dataCS: [],
      config: {
        altInput: true,
        altFormat: 'F j, Y',
        dateFormat: 'Y-m-d'
      },
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: false
      },
      money2: {
        decimal: ',',
        thousands: '.',
        prefix: 'IDR ',
        suffix: '',
        precision: 0,
        masked: false
      },
      formType: 'lostAndFound',
      itemsPaymentCard: [],
      itemsPaymentType: [],
      detailMember: {},
      detailCS: {},
      CSName: '',
      modalShow: false,
      linkPrivyId: 'https://sandbox.privy.id/user',
      configTimeDate2: {
        enableTime: true,
        noCalendar: true,
        defaultDate: "00:00",
        static: true,
        time_24hr: true
      },
      configTimeDate: {
        enableTime: true,
        noCalendar: false,
        // defaultDate: "00:00",
        altInput: true,
        altFormat: "j F Y, H:i",
        time_24hr: true
      },
      editData: {
        branch_id: null,
        customer_service_id: null,
        detail_reason: '',
        which_found_name: '',
        which_area: '',
        time_found: '',
        what_item: '',
        who_return_item_name: '',
        return_item_time: '',
        customer_service_serve_id: null
      }
    }
  },
  methods: {
    getCSData (event) {
      axios.get('crm/v1/customer_service/' + event).then(response => {
        this.detailCS = response.data.data
        this.CSName = response.data.data.name
        // console.log('test', response)
      }).catch(error => {
        console.log('error', error)
      })
    },
    formSelect (event) {
      return event
    },
    changeValueMoney (event) {
      if (!(event.key === '')) {
        this.$refs['error-print'].classList.add('hidden')
      } else {
        this.$refs['error-print'].classList.remove('hidden')
      }
    },
    validateLostAndFound (data5) {
      this.$validator.validateAll(data5).then((result) => {
        if(result) {
          // console.log(moment(new Date(this.editData.time_found)).format('MMMM'))
          let data1 = Object.assign({}, this.editData)
          delete data1.customer_service1
          delete data1.customer_service2
          delete data1.id
          let data2 = data1
          // console.log(this.editData)
          // console.log('data2', data2)
          axios.put('crm/v1/form_lost_found/' + this.$route.query.id, data2).then(response => {
            console.log('test', response)
            this.$router.push('/allForm')
            this.$toast.success('data saved successfully!', 'Success', {
              position: 'topCenter',
              icon: 'icon-envelope',
              progressBarColor: 'rgb(0, 255, 184)',
              theme: 'dark',
              backgroundColor: '#565c70',
              messageColor: '#fff'
            })
          }).catch(error => {
            // console.log('error log', error)
            this.$toast.success('cant saved data!', 'Error', {
              position: 'topCenter',
              icon: 'icon-envelope',
              progressBarColor: 'rgb(0, 255, 184)',
              theme: 'dark',
              backgroundColor: '#565c70',
              messageColor: '#fff'
            })
          })
        } else {
          this.$toast.success('please fill in required fields!', 'Error', {
            position: 'topCenter',
            icon: 'icon-envelope',
            progressBarColor: 'rgb(0, 255, 184)',
            theme: 'dark',
            backgroundColor: '#565c70',
            messageColor: '#fff'
          })
        }
      })
    },
    changeBranch(event) {
      this.editData.customer_service_id = null
      this.editData.customer_service_serve_id = ''
      axios.get('crm/v1/customer_service?branch_id=' + event).then(response => {
        this.dataCS = response.data.data.rows
      }).catch(error => {
        console.log('error', error)
      })
    },
    openPage (event) {
      this.$router.push(event)
    },
    async fetchData() {
      let response = await axios.get('crm/v1/form_lost_found/' + this.$route.query.id)
      this.getCSData(response.data.data.customer_service1.id)
      this.editData = response.data.data

      const year = moment(this.editData.created_at).format('YYYY')
      const month = moment(this.editData.created_at).format('M')
      
      axios.get('crm/v1/closing_period/member_pt_session?year='+year+'&bulan='+month).then(response => {
        this.disableBtnSubmit = true
      }).catch(error => {
        console.log('error', error)
      })

      // axios.get('fitness/v1/member/').then(response => {
      //   this.dataMember = response.data.data.rows
      // }).catch(error => {
      //   console.log('error', error)
      // })
      axios.get('transaction/v1/payment_card').then(response => {
        this.itemsPaymentCard = response.data.data.rows
      }).catch(error => {
        console.log('error', error)
      })
      axios.get('transaction/v1/payment_type').then(response => {
        this.itemsPaymentType = response.data.data.rows
      }).catch(error => {
        console.log('error', error)
      })
      axios.get('crm/v1/customer_service?branch_id=' + this.editData.branch_id).then(response => {
        this.dataCS = response.data.data.rows
      }).catch(error => {
        console.log('error', error)
      })
      axios.get('fitness/v1/branch/').then(response => {
        this.dataBranch = response.data.data.rows
      }).catch(error => {
        console.log('error', error)
      })
    }
  },
  created () {
    this.fetchData()
  }
}
</script>

<style>
</style>
